import React from "react";
import ReactTable from "react-table";
import { ReporteLiderComercialMockUp } from "./ReporteLiderComercial.types";

interface Props {
  data: ReporteLiderComercialMockUp[];
  onExport: () => void;
}

export const ReporteLiderComercialTable: React.FC<Props> = ({
  data,
  onExport
}) => {
  const columns = [
    {
      Header: "Num. Empleado",
      accessor: "numEmpleado"
    },
    {
      Header: "Empleado",
      accessor: "empleado"
    },
    {
      Header: "Ventas",
      accessor: "ventas"
    },
    {
      Header: "Reactivaciones",
      accessor: "reactivaciones"
    },
    {
      Header: "Integrantes",
      accessor: "integrantes"
    },
    {
      Header: "Extras",
      accessor: "extras"
    },
    {
      Header: "Rescuentos",
      accessor: "rescuentos"
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <h5>8 Asesores</h5>
        <button className="btn btn-primary" onClick={onExport}>
          Exportar
        </button>
      </div>
      <ReactTable
        data={data}
        columns={columns}
        defaultPageSize={10}
        sortable={false}
        resizable={false}
        showPagination={false}
        className="-striped -highlight"
        previousText="Anterior"
        nextText="Siguiente"
        loadingText="Cargando..."
        noDataText="No hay registros"
        pageText="Página"
        ofText="de"
        rowsText="filas"
      />
    </div>
  );
};
